/* ============================================================
   EBH — Menu mobile em acordeão
   Carregar num nível abre o nível seguinte por baixo, no mesmo ecrã.
   Substitui o painel que deslizava para o lado.
   Ver snippets/drawer-menu-list.liquid + ebh-drawer-accordion.css
   ============================================================ */
(function () {
  'use strict';

  // O snippet pode emitir a tag <script> mais do que uma vez (menu principal e
  // secundário). Arrancar duas vezes duplicaria cada toque.
  if (window.__ebhDrawerAccordion) return;
  window.__ebhDrawerAccordion = true;

  var TOGGLE = '[data-ebh-acc-toggle]';
  var ITEM = '[data-ebh-acc-item]';
  var DURATION = 320;
  var MARGIN = 8; // folga acima da linha tocada quando o scroll a leva ao topo

  function prefersReducedMotion() {
    return (
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function panelOf(toggle) {
    var id = toggle.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (panel) return panel;

    // Rede de segurança: o painel é sempre irmão do botão dentro do mesmo <li>.
    var item = toggle.closest(ITEM);
    return item ? item.querySelector(':scope > [data-ebh-acc-panel]') : null;
  }

  function isOpen(toggle) {
    return toggle.getAttribute('aria-expanded') === 'true';
  }

  // Enquanto um painel está aberto a altura fica em "none" para que abrir um
  // nível mais fundo não seja cortado pelo painel de cima.
  function releaseAncestors(panel) {
    var parent = panel.parentElement;
    while (parent && parent !== document.body) {
      if (parent.hasAttribute && parent.hasAttribute('data-ebh-acc-panel')) {
        parent.style.maxHeight = 'none';
      }
      parent = parent.parentElement;
    }
  }

  function onPanelTransitionEnd(panel, callback) {
    var done = function (event) {
      if (event.target !== panel || event.propertyName !== 'max-height') return;
      panel.removeEventListener('transitionend', done);
      window.clearTimeout(panel._ebhAccTimer);
      callback();
    };

    panel.addEventListener('transitionend', done);

    // transitionend não chega se a transição for interrompida.
    window.clearTimeout(panel._ebhAccTimer);
    panel._ebhAccTimer = window.setTimeout(function () {
      panel.removeEventListener('transitionend', done);
      callback();
    }, DURATION + 80);
  }

  // O tema fixa uma ALTURA EM PIXELS no contentor do menu (`.drawer-menu__main`,
  // [data-main]) quando o drawer abre — era para animar o painel lateral que
  // este acordeão substituiu — e o CSS do tema corta lá o que sobra, com
  // `overflow: hidden`. Enquanto essa altura estiver presa, abrir um nível não
  // mostra nada por baixo do corte E o contentor que rola (.drawer-menu__contents)
  // fica sem nada para rolar: o filho tem altura fixa, logo scrollHeight é igual
  // a clientHeight. A 18/09/2026 isso escondia no telemóvel 12 links da primeira
  // secção — Pool, Pop Dots, New Party, o SALE e o Register / Login incluídos —
  // e o keepInView daqui de baixo pedia scroll a um contentor que não rolava.
  // Soltar a altura devolve as duas coisas de uma vez.
  function soltarAlturaDoDrawer(element) {
    if (!element || !element.closest) return;
    var main = element.closest('[data-main]');
    if (main && main.style.height !== 'auto') main.style.height = 'auto';
  }

  function open(toggle) {
    var panel = panelOf(toggle);
    if (!panel || isOpen(toggle)) return;

    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    releaseAncestors(panel);
    soltarAlturaDoDrawer(panel);

    if (prefersReducedMotion()) {
      panel.style.maxHeight = 'none';
      keepInView(toggle, panel);
      return;
    }

    panel.style.maxHeight = panel.scrollHeight + 'px';

    // O scroll só acerta depois de a altura estar feita — antes disso o
    // contentor ainda não tem para onde rolar.
    onPanelTransitionEnd(panel, function () {
      if (!isOpen(toggle)) return;
      panel.style.maxHeight = 'none';
      keepInView(toggle, panel);
    });
  }

  function close(toggle) {
    var panel = panelOf(toggle);
    if (!panel || !isOpen(toggle)) return;

    toggle.setAttribute('aria-expanded', 'false');
    collapseDescendants(panel);
    soltarAlturaDoDrawer(panel);

    if (prefersReducedMotion()) {
      panel.style.maxHeight = '';
      panel.hidden = true;
      return;
    }

    panel.style.maxHeight = panel.scrollHeight + 'px';
    void panel.offsetHeight; // força o browser a assumir a altura antes de fechar
    panel.style.maxHeight = '0px';

    onPanelTransitionEnd(panel, function () {
      if (isOpen(toggle)) return;
      panel.hidden = true;
      panel.style.maxHeight = '';
    });
  }

  // Fechar um nível fecha o que está lá dentro, para reabrir limpo.
  function collapseDescendants(panel) {
    var toggles = panel.querySelectorAll(TOGGLE);
    for (var i = 0; i < toggles.length; i++) {
      var child = toggles[i];
      if (!isOpen(child)) continue;
      child.setAttribute('aria-expanded', 'false');
      var childPanel = panelOf(child);
      if (!childPanel) continue;
      childPanel.style.maxHeight = '';
      childPanel.hidden = true;
    }
  }

  // Quem rola é o contentor do drawer, não a página (o body fica travado
  // enquanto o menu está aberto).
  function scrollerOf(element) {
    var node = element.parentElement;

    while (node && node !== document.body && node !== document.documentElement) {
      var overflowY = window.getComputedStyle(node).overflowY;
      if (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') {
        return node;
      }
      node = node.parentElement;
    }

    return null;
  }

  // Depois de abrir: se o nível aberto não couber todo, rolar o que falta —
  // mas nunca ao ponto de a linha que se tocou sair pelo topo. Quem abriu tem
  // de continuar a ver o que abriu.
  function keepInView(toggle, panel) {
    var scroller = scrollerOf(panel);
    var topEdge = 0;
    var bottomEdge = window.innerHeight || document.documentElement.clientHeight;

    if (scroller) {
      var scrollerRect = scroller.getBoundingClientRect();
      topEdge = Math.max(topEdge, scrollerRect.top);
      bottomEdge = Math.min(bottomEdge, scrollerRect.bottom);
    }

    var missing = panel.getBoundingClientRect().bottom - bottomEdge;
    if (missing <= 1) return;

    var room = Math.max(toggle.getBoundingClientRect().top - topEdge - MARGIN, 0);
    var delta = Math.min(missing, room);
    if (delta <= 1) return;

    scrollDown(scroller, delta);
  }

  function scrollDown(scroller, delta) {
    var target = scroller || window;

    try {
      target.scrollBy({
        top: delta,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
      return;
    } catch (error) {
      // Safari antigo não aceita o objecto de opções.
    }

    if (scroller) {
      scroller.scrollTop += delta;
    } else {
      window.scrollBy(0, delta);
    }
  }

  // Captura: o tema tem os seus próprios handlers em .drawer-menu__link e não
  // queremos que o painel lateral antigo chegue a arrancar.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var toggle = target.closest(TOGGLE);
      if (!toggle) return;

      event.preventDefault();
      event.stopPropagation();

      if (isOpen(toggle)) {
        close(toggle);
      } else {
        open(toggle);
      }
    },
    true
  );
})();
